/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {};
